import React from "react";
import AppleLogin from "react-apple-login";
import { useDispatch } from "react-redux";
import { socialLogin } from "../../store/actions/authActions";

/**
 * BOC
 * API Security - Step 4 OTP login / signup UI
 * date 23-10-2026
 * use_of_code: Apple returns the id_token (responseType "code id_token", scope "name email"). The server verifies
 * the token with the Apple keys and takes the e-mail from it, so the separate "Enter Email" screen is not needed.
 * Apple needs responseMode "form_post" when the scope is requested (the popup still returns the response here).
 */
function AppleAuth() {
  const dispatch = useDispatch();

  const appleResponse = (res) => {
    if (!res || res.error || !res?.authorization?.id_token) {
      return;
    }
    const userDetails = {
      apple_id: "",
      first_name: res?.user?.name?.firstName || "",
      last_name: res?.user?.name?.lastName || "",
      telephone: "",
      country_id: "",
      email: "",
      dob: "",
      password: "",
      user_type: "guest",
      social_login: "yes",
      is_seller: "0",
      city: "",
      postcode: "",
      company: "",
      confirm: "",
      fax: "",
      address_1: "",
      address_2: "",
      provider: "apple",
      token: res.authorization.id_token,
    };
    dispatch(socialLogin(userDetails, "apple"));
  };

  return (
    <div>
      <AppleLogin
        clientId={"com.darveys.app.sid"}
        redirectURI={"https://www.darveys.com"}
        responseType={"code id_token"}
        responseMode={"form_post"}
        scope={"name email"}
        usePopup={true}
        callback={appleResponse}
        render={renderProps => (
          <a onClick={renderProps.onClick} disabled={renderProps.disabled} href="#0"><img src="../assets/images/icons/apple.png" alt="" /></a>
        )}
        designProp={{
          height: 30,
          width: 140,
          color: "black",
          border: false,
          type: "sign-in",
          border_radius: 15,
          scale: 1,
          locale: "en_US",
        }}
      />
    </div>
  );
}
/**
 * EOC
 */

export default AppleAuth;
